<app-simple-stacked-bar-chart
  [data]="data"
  [loading]="isLoading"
  [leftLabel]="'charts.labels.tutor' | translate"
  [rightLabel]="'charts.labels.sessions' | translate"
></app-simple-stacked-bar-chart>
